import script from "./PostCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostCard.vue?vue&type=script&lang=ts&setup=true"

import "../../assets/css/post-card.css?vue&type=style&index=0&id=53eb9ab9&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53eb9ab9"]])

export default __exports__